<template>
  <div class="plugin-redirect-container">
    <div>
      <el-row style="margin-top: 50px">
        <el-col :span="3">
          <el-select  v-model="appid" size="mini" filterable placeholder="请选择游戏" allow-create>
            <el-option-group label="全部游戏">
              <el-option
                  v-for="item in recentGames.filter(item => item.game_appid.indexOf('wx')>-1)"
                  :key="item.game_appid"
                  :label="item.game_name"
                  :value="item.game_appid">
                <span style="float: left">{{ item.game_name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 5px">  {{item.game_appid}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-date-picker
              size="mini"
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="get">
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <el-radio-group v-model="groupType" size="mini">
            <el-radio-button label="none">不分组</el-radio-button>
            <el-radio-button label="date">按日期分组</el-radio-button>
            <el-radio-button label="cidDate">按计划ID和日期分组</el-radio-button>
            <el-radio-button label="aid">按广告ID分组</el-radio-button>
          </el-radio-group>
          <el-button size="mini" @click="get">查询</el-button>


          <!-- 添加列设置按钮 -->
          <el-button size="mini" @click="showColumnSettings = true">列设置</el-button>

          <el-button size="mini" @click="upadateToken" type="danger" style="margin-left: 5px">刷新接口调用凭证</el-button>
        </el-col>
      </el-row>
    </div>

    <el-table :data="displayData" size="mini" style="width: 100%" border
              max-height="calc(100vh - 180px)"
              height="calc(100vh - 180px)"
              v-loading="loading"
              :header-cell-style="{background: '#f5f7fa', color: '#606266', fontWeight: 'bold'}"
              :row-class-name="tableRowClassName">

      <el-table-column prop="aid" label="广告ID" width="160" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
    <span @click="filterAid(scope.row.aid)" style="color: blue; cursor: pointer;">
      {{ scope.row.aid }}
    </span>
        </template>
      </el-table-column>

      <el-table-column
          v-for="column in visibleColumns"
          :key="column.prop"
          :prop="column.prop"
          ref="t"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :align="column.align"
          :sortable="column.sortable"
          :show-tooltip-when-overflow="column.showOverflowTooltip"
          :formatter="column.formatter">
        <template slot-scope="scope">
          <!-- 点击率字段 -->
          <span v-if="column.prop === 'advertise_ad_clk_ratio'">
      {{ (scope.row.advertise_ad_clk_ratio * 100).toFixed(2) + '%' }}
    </span>
          <!-- ROI字段 -->
          <span v-else-if="column.prop === 'ad_roi'" :class="getRoiClass(scope.row.ad_roi)">
      {{ scope.row.ad_roi ? parseFloat(scope.row.ad_roi).toFixed(2) : '0.00' }}
    </span>
          <!-- 注册成本字段 -->
          <span v-else-if="column.prop === 'reg_paid'">
      {{ scope.row.advertise_reg_uv && scope.row.advertise_reg_uv !== 0
              ? (scope.row.advertise_ad_cost/scope.row.advertise_reg_uv).toFixed(2)
              : '0.00' }}
    </span>
          <!-- ECPM字段 -->
          <span v-else-if="column.prop === 'ecpm'">
      <span v-if="scope.row.monetize_exp_cnt_1d && scope.row.monetize_exp_cnt_1d !== 0">
        {{ (scope.row.monetize_ad_income / scope.row.monetize_exp_cnt_1d * 1000).toFixed(2) }}
      </span>
      <span v-else>0.00</span>
    </span>

          <!-- ad_roi3 -->
          <span v-else-if="column.prop === 'ad_roi3'">
        {{ scope.row.monetize_ad_income_3d && scope.row.monetize_ad_income_3d !== 0&& scope.row.advertise_ad_cost&& scope.row.advertise_ad_cost!==0
              ? (scope.row.monetize_ad_income_3d / scope.row.advertise_ad_cost).toFixed(2)
              : '0.00' }}
      </span>
          <!-- ad_roi7 -->
          <span v-else-if="column.prop === 'ad_roi7'">
        {{ scope.row.monetize_ad_income_7d && scope.row.monetize_ad_income_7d !== 0&& scope.row.advertise_ad_cost&& scope.row.advertise_ad_cost!==0
              ? (scope.row.monetize_ad_income_7d / scope.row.advertise_ad_cost).toFixed(2)
              : '0.00' }}
      </span>

          <!-- 当日人均视频次数字段 -->
          <span v-else-if="column.prop === 'avg_video'">
        {{ scope.row.advertise_reg_uv && scope.row.advertise_reg_uv !== 0&& scope.row.monetize_exp_cnt_1d&& scope.row.monetize_exp_cnt_1d!==0
              ? (scope.row.monetize_exp_cnt_1d / scope.row.advertise_reg_uv).toFixed(2)
              : '0.00' }}
      </span>
          <!-- 当日变现人数占比字段 -->
          <span v-else-if="column.prop === 'monetize_uv_ratio'">
        {{ scope.row.advertise_reg_uv && scope.row.advertise_reg_uv !== 0&& scope.row.monetize_uv_1d&& scope.row.monetize_uv_1d!==0
              ? (scope.row.monetize_uv_1d / scope.row.advertise_reg_uv * 100).toFixed(2) + '%'
              : '0.00%' }}
      </span>
          <!-- 其他字段使用常规显示 -->
          <span v-else>
      {{ getColumnValue(scope.row, column) }}
    </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 列设置弹窗 -->
    <el-dialog title="列设置" :visible.sync="showColumnSettings" width="600px">
      <el-alert
          title="拖拽排序，勾选控制显示/隐藏"
          type="info"
          show-icon
          :closable="false">
      </el-alert>

      <el-table
          :data="columnSettings"
          ref="dragTable"
          row-key="prop"
          style="margin-top: 20px;">
        <el-table-column label="拖拽排序" width="60">
          <template slot-scope="{$index}">
            <i class="el-icon-rank" style="cursor: move;">{{ $index}}</i>
          </template>
        </el-table-column>
        <el-table-column label="显示/隐藏" width="100">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.visible"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="label" label="列名"></el-table-column>
        <el-table-column prop="prop" label="字段名"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetColumnSettings">重置</el-button>
        <el-button type="primary" @click="saveColumnSettings">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 折线图弹窗 -->
    <el-dialog title="广告ROI趋势图" :visible.sync="showRoiChart" width="1200px">
      <div ref="roiChart" style="width: 100%; height: 400px;"></div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import * as echarts from 'echarts';
export default {
  name: "pluginRedirect",
  data() {
    return {
      showRoiChart: false, // 控制折线图弹窗的显示
      currentAdRoiData: [], // 存储当前广告的ROI数据
      date:[],
      appid: '',
      realTimeRoiData: [],
      recentGames: [],
      real_time_stat_by_reg_date_list: [],
      displayData: [],
      projectList: [],
      groupType: 'aid', // none, date, aidDate
      loading:false,
      showColumnSettings: false,
      // 默认列配置
      defaultColumnSettings: [
        { prop: 'ds', label: '日期', width: '100', align: 'left', visible: true },
        { prop: 'advertiserId', label: '账户ID', minWidth: '160', align: 'left', visible: true, showOverflowTooltip: true },
        { prop: 'cid', label: '计划ID', minWidth: '160', align: 'left', visible: true, showOverflowTooltip: true },
        // { prop: 'aid', label: '广告ID', minWidth: '160', align: 'left', visible: true, showOverflowTooltip: true },
        { prop: 'advertise_ad_cost', label: '广告消耗(元)', width: '120', align: 'right', visible: true,sortable: true, formatter: this.formatValue },
        { prop: 'reg_paid', label: '注册成本', width: '120', align: 'right', visible: true, scopedSlots: true },
        { prop: 'ecpm', label: '变现ecpm', width: '120', align: 'right', visible: true, scopedSlots: true },
        { prop: 'projectType', label: '项目类型', width: '120', align: 'right', visible: true },
        { prop: 'validClickCount', label: '出价', width: '120', align: 'right', visible: true },
        { prop: 'ad_roi', label: '当日ROI', width: '100', align: 'right', visible: true, scopedSlots: true },

        { prop: 'ad_roi3', label: '3日ROI', width: '100', align: 'right', visible: true, scopedSlots: true },
        { prop: 'ad_roi7', label: '7日ROI', width: '100', align: 'right', visible: true, scopedSlots: true },
        { prop: 'avg_video', label: '当日人均广告次数', width: '130', align: 'right', visible: true, scopedSlots: true },
        { prop: 'monetize_uv_ratio', label: '当日变现人数占比', width: '130', align: 'right', visible: true, scopedSlots: true },

        { prop: 'advertise_ad_clk_ratio', label: '外渠点击率', width: '120', align: 'right', visible: true, scopedSlots: true },
        { prop: 'monetize_ad_income', label: '广告收入(元)', width: '120', align: 'right', visible: true, formatter: this.formatValue },
        { prop: 'monetize_ad_income_3d', label: '3日广告收入(元)', width: '120', align: 'right', visible: true, formatter: this.formatValue },
        { prop: 'monetize_ad_income_7d', label: '7日广告收入(元)', width: '120', align: 'right', visible: true, formatter: this.formatValue },
        { prop: 'advertise_reg_uv', label: '注册用户数', width: '120', align: 'right', visible: true },
        { prop: 'monetize_uv_1d', label: '当日变现人数', width: '120', align: 'right', visible: true },
        { prop: 'monetize_exp_cnt_1d', label: '当日观看广告次数', width: '120', align: 'right', visible: true },
          { prop: 'advertise_ad_exp_cnt', label: '外渠曝光量', width: '120', align: 'right', visible: true },
          { prop: 'advertise_ad_clk_cnt', label: '外渠点击量', width: '120', align: 'right', visible: true },

      ],

      columnSettings: [

      ],
      sortable: null
    }
  },
  computed: {
    visibleColumns() {
      return this.columnSettings.filter(column => column.visible);
    }
  },
  methods:{
    filterAid(adId){
      // 如果已经筛选过，再次点击同一个广告 ID 则恢复原始数据
      if (this.isFiltered && this.currentFilterAid === adId) {
        this.displayData = this.originalDisplayData;
        this.originalDisplayData = null;
        this.currentFilterAid = null;
        this.isFiltered = false;

        this.$message({
          message: '已取消筛选，显示全部数据',
          type: 'info'
        });
        return;
      }

      // 计算最近 10 天的日期范围
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 9); // 包括今天共 10 天

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const recent10DaysStart = formatDate(startDate);
      const recent10DaysEnd = formatDate(endDate);

      // 保存当前的查询条件
      const currentAppid = this.appid;
      const currentDate = [...this.date];

      // 显示加载提示
      const loadingMsg = this.$loading({
        lock: true,
        text: '正在获取最近 10 天数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 临时修改日期为最近 10 天，查询数据
      this.date = [recent10DaysStart, recent10DaysEnd];

      // 调用接口获取最近 10 天的数据
      this.$axios
          .get('/toufang/data/getExtChanRealTimeRoi/' + recent10DaysStart + '/' + recent10DaysEnd + '/' + currentAppid, {})
          .then(successResponse => {
            loadingMsg.close();

            if (successResponse.data.code === 200 && !successResponse.data.data.errcode) {
              // 保存原始数据（用户当前查询的全部数据）
              if (!this.originalDisplayData) {
                this.originalDisplayData = [...this.displayData];
              }

              // 处理新获取的最近 10 天数据
              const recent10DaysData = successResponse.data.data.real_time_roi_data_list || [];
              const real_time_stat_by_reg_date_list = successResponse.data.data.real_time_stat_by_reg_date_list || [];
              const projectList = successResponse.data.data.projectList || [];

              // 临时保存这些列表用于合并
              const tempRealTimeRoiData = this.realTimeRoiData;
              const tempRealTimeStatList = this.real_time_stat_by_reg_date_list;
              const tempProjectList = this.projectList;

              // 替换为最近 10 天的数据
              this.realTimeRoiData = recent10DaysData;
              this.real_time_stat_by_reg_date_list = real_time_stat_by_reg_date_list;
              this.projectList = projectList;

              // 合并数据
              const mergedData = this.mergeDataByAidCidDs();

              // 按当前分组类型处理
              let filteredData = [];
              switch(this.groupType) {
                case 'none':
                  filteredData = mergedData;
                  break;
                case 'date':
                  filteredData = this.groupByDate(mergedData);
                  break;
                case 'aidDate':
                  filteredData = this.groupByAidAndDate(mergedData);
                  break;
                case 'cidDate':
                  filteredData = this.groupByCidAndDate(mergedData);
                  break;
                case 'aid':
                  filteredData = this.groupByAid(mergedData);
                  break;
                default:
                  filteredData = mergedData;
              }

              // 筛选指定广告 ID 的数据
              this.displayData = filteredData.filter(item => item.aid === adId);

              // 恢复原来的数据列表（保持页面显示的日期不变）
              this.realTimeRoiData = tempRealTimeRoiData;
              this.real_time_stat_by_reg_date_list = tempRealTimeStatList;
              this.projectList = tempProjectList;

              // 恢复原来的日期选择框
              this.date = currentDate;

              // 更新筛选状态
              this.currentFilterAid = adId;
              this.isFiltered = true;

              this.$message({
                message: `已筛选广告 ID: ${adId} 最近 10 天 (${recent10DaysStart} 至 ${recent10DaysEnd}) 的数据，共 ${this.displayData.length} 条`,
                type: 'success',
                duration: 3000
              });
            } else {
              this.$message({
                message: '获取最近 10 天数据失败',
                type: 'warning'
              });
            }
          })
          .catch(error => {
            loadingMsg.close();
            this.date = currentDate; // 恢复日期
            console.error('获取最近 10 天数据失败:', error);
            this.$message({
              message: '网络错误，请稍后重试',
              type: 'error'
            });
          });
    },
    // 显示ROI折线图
    showRoiLineChart(adId) {
      // 获取该广告的ROI数据（模拟请求）
      this.fetchAdRoiData(adId).then((data) => {
        this.currentAdRoiData = data;
        this.showRoiChart = true;
        this.$nextTick(() => {
          this.renderRoiChart();
        });
      });
    },

    // 模拟获取广告ROI数据的API
    fetchAdRoiData(adId) {
      return new Promise((resolve) => {
        // 从 displayData 中筛选出指定广告ID的数据
        const filteredData = this.groupByAidAndDate(this.mergeDataByAidCidDs()).filter(item => item.aid === adId);
        const gameData = this.groupByDate(this.mergeDataByAidCidDs())
        // 构造符合 ECharts 折线图格式的数据
        const chartData = filteredData.map(item => ({
          date: item.ds, // 使用日期字段作为横轴
          roi: (item.monetize_ad_income/item.advertise_ad_cost*100).toFixed(2) || 0, // 当日ROI
          roi3: (item.monetize_ad_income_3d/item.advertise_ad_cost*100).toFixed(2) || 0, // 3日ROI
          roi7: (item.monetize_ad_income_7d/item.advertise_ad_cost*100).toFixed(2) || 0,  // 7日ROI
          cost:item.advertise_ad_cost||0,
        }));
        // 将 gameData 按照 date 相同的加入 chartData
        gameData.forEach(gameItem => {
          const existingItem = chartData.find(chartItem => chartItem.date === gameItem.ds);
          if (existingItem) {
            // 如果 chartData 中已存在相同日期的数据，则添加 gameRoi 字段
            existingItem.gameRoi = (gameItem.monetize_ad_income / gameItem.advertise_ad_cost*100).toFixed(2) || 0;
            existingItem.gameRoi3 = (gameItem.monetize_ad_income_3d / gameItem.advertise_ad_cost*100).toFixed(2) || 0;
            existingItem.gameRoi7 = (gameItem.monetize_ad_income_7d / gameItem.advertise_ad_cost*100).toFixed(2) || 0;
            existingItem.gameCost = ( gameItem.advertise_ad_cost).toFixed(2) || 0;
          }
          // else {
          //   // 如果 chartData 中不存在该日期的数据，则新增一条记录
          //   chartData.push({
          //     date: gameItem.ds,
          //     gameRoi: (gameItem.monetize_ad_income / gameItem.advertise_ad_cost*100).toFixed(2) || 0,
          //     gameRoi3: (gameItem.monetize_ad_income_3d / gameItem.advertise_ad_cost*100).toFixed(2) || 0,
          //     gameRoi7: (gameItem.monetize_ad_income_7d / gameItem.advertise_ad_cost*100).toFixed(2) || 0,
          //     gameCost:gameItem.advertise_ad_cost||0,
          //   });
          // }
        });
        // 模拟异步请求延迟
        setTimeout(() => {
          resolve(chartData);
        }, 500);
      });
    },

    // 渲染折线图
    renderRoiChart() {
      const chartDom = this.$refs.roiChart;
      const myChart = echarts.init(chartDom);

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let tooltipContent = '';
            const date = params[0].name; // 获取横轴日期
            tooltipContent += `<strong>日期: ${date}</strong><br/>`;

            // 分别处理广告维度和游戏维度的数据
            const adData = [];
            const gameData = [];

            params.forEach(item => {
              if (item.seriesName.includes('广告')) {
                adData.push(`${item.seriesName}: ${item.value}`);
              } else if (item.seriesName.includes('游戏')) {
                gameData.push(`${item.seriesName}: ${item.value}`);
              }
            });

            // 广告维度数据
            if (adData.length > 0) {
              tooltipContent += '<br/><strong>广告维度:</strong><br/>';
              adData.forEach(data => {
                tooltipContent += `${data}<br/>`;
              });
            }

            // 游戏维度数据
            if (gameData.length > 0) {
              tooltipContent += '<br/><strong>游戏维度:</strong><br/>';
              gameData.forEach(data => {
                tooltipContent += `${data}<br/>`;
              });
            }

            return tooltipContent;
          }
        },
        legend: {
          data:[
              {name: '当日广告ROI', icon: 'circle'},
              {name: '3日广告ROI', icon: 'circle'},
              {name: '7日广告ROI', icon: 'circle'},
            {name: '广告消耗', icon: 'circle'},
            '\n',  // 换行
              {name: '当日游戏ROI', icon: 'circle'},
              {name: '3日游戏ROI', icon: 'circle'},
              {name: '7日游戏ROI', icon: 'circle'},
              {name: '游戏消耗', icon: 'circle'},
            ]

        },
        xAxis: {
          type: 'category',
          data: this.currentAdRoiData.map(item => item.date),
        },
        yAxis: [
          {
            type: 'value',
            name: '消耗',
            min: 0,
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#999'
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: 'ROI%',
            position: 'right',
            axisLine: {
              lineStyle: {
                color: '#666'
              }
            },
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: [
          {
            name: '当日广告ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentAdRoiData.map(item => item.roi),
            itemStyle: {
              color: '#ee6666'  // 统一颜色
            },
          },
          {
            name: '3日广告ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentAdRoiData.map(item => item.roi3),
            itemStyle: {
              color: '#2686cb'  // 统一颜色
            },
          },
          {
            name: '7日广告ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentAdRoiData.map(item => item.roi7),
            itemStyle: {
              color: '#e37e0b'  // 统一颜色
            },
          },
          {
            name: '当日游戏ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentAdRoiData.map(item => item.gameRoi),
            itemStyle: {
              color: '#ee6666'  // 统一颜色
            },
            lineStyle: {
              type: 'dashed' // 设置为虚线
            }
          },
          {
            name: '3日游戏ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentAdRoiData.map(item => item.gameRoi3),
            itemStyle: {
              color: '#2686cb'  // 统一颜色
            },
            lineStyle: {
              type: 'dashed' // 设置为虚线
            }
          },
          {
            name: '7日游戏ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentAdRoiData.map(item => item.gameRoi7),
            itemStyle: {
              color: '#e37e0b'  // 统一颜色
            },
            lineStyle: {
              type: 'dashed' // 设置为虚线
            }
          },
          {
            name: '广告消耗',
            type: 'bar',

            yAxisIndex: 0,
            data: this.currentAdRoiData.map(item => item.cost),
            itemStyle: {
              color: '#5470c6'
            },
            barWidth: '15px',
            show: true
          },
          {
            name: '游戏消耗',
            type: 'bar',
            yAxisIndex: 0,
            data:this.currentAdRoiData.map(item => item.gameCost),
            itemStyle: {
              color: '#a254d0'
            },
            barWidth: '15px',
            show: true
          },
        ],
      };

      myChart.setOption(option);
    },

    // 初始化游戏和日期缓存
    initCache() {
      // 初始化游戏缓存
      const savedAppid = localStorage.getItem('pluginRedirectAppid');
      if (savedAppid) {
        this.appid = savedAppid;
      }

      // 初始化日期缓存
      const savedDate = localStorage.getItem('pluginRedirectDate');
      if (savedDate) {
        try {
          this.date = JSON.parse(savedDate);
        } catch (e) {
          // 如果解析失败，设置默认日期
          this.setDefaultDate();
        }
      } else {
        // 如果没有缓存，设置默认日期
        this.setDefaultDate();
      }
    },

    // 设置默认日期范围（最近7天）
    setDefaultDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 );
      this.date = [this.formatDate(start), this.formatDate(end)];
    },

    // 保存查询条件到缓存
    saveQueryToCache() {
      if (this.appid) {
        localStorage.setItem('pluginRedirectAppid', this.appid);
      }
      if (this.date && this.date.length === 2) {
        localStorage.setItem('pluginRedirectDate', JSON.stringify(this.date));
      }
    },

    // 格式化日期的方法（如果还没有的话）
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 获取列值的方法
    getColumnValue(row, column) {
      const value = row[column.prop];
      // 如果有formatter则使用formatter处理
      if (column.formatter) {
        return column.formatter(row, column);
      }
      // 特殊处理某些字段
      if (column.prop === 'advertise_reg_uv' && (!value || value === 0)) {
        return '0';
      }
      return value !== undefined && value !== null ? value : '';
    },
    findGame() {
      this.$axios
          .get('https://chengmei.games:4443/api/data/findGameInfo', {})
          .then(successResponse => {
            this.recentGames = successResponse.data.data
          })
    },

    formatValue: function (row, column) {
      const value = row[column.prop];
      // 添加空值检查和默认值处理
      if (value === undefined || value === null || value === '') {
        return '0.0';
      }
      // 检查是否为有效数字
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        return '0.0';
      }
      return numValue.toFixed(2);
    },
    get(){
      if(this.date.length === 0||this.appid === ''){
        this.$message({
          message: '请选择日期和游戏！',
          type: 'warning'
        });
        return
      }
      // 初始化列设置
      this.initColumnSettings()
      console.log('get')
      this.displayData= []
      this.realTimeRoiData = []
      this.loading = true
      this.$axios
          .get('/toufang/data/getExtChanRealTimeRoi/'+this.date[0]+'/'+this.date[1]+'/'+this.appid, {})
          .then(successResponse => {
            if (successResponse.data.code === 200) {
              this.loading = false

              if(successResponse.data.data.errcode){
                console.log(successResponse.data.data.errcode)

                this.$message({
                  message: '接口调用凭证失效!'+successResponse.data.data.errmsg,
                  type: 'warning'
                });
                return;
              }

              this.realTimeRoiData = successResponse.data.data.real_time_roi_data_list
              this.real_time_stat_by_reg_date_list = successResponse.data.data.real_time_stat_by_reg_date_list
              console.log(this.realTimeRoiData)
              this.projectList = successResponse.data.data.projectList || []
              // 更新显示数据
              this.updateDisplayData()

              // 保存查询条件到缓存
              this.saveQueryToCache()
            } else {
              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });
            }
          })
    },
    handleGroupChange() {
      this.updateDisplayData()
    },
    // 在 mergeDataByAidCidDs 方法中添加 projectList 的处理逻辑
    // 修改 mergeDataByAidCidDs 方法中的 projectList 处理逻辑
    mergeDataByAidCidDs() {
      // 创建一个映射来存储 real_time_stat_by_reg_date_list 数据
      const statMap = new Map();

      // 将 real_time_stat_by_reg_date_list 数据以 aid_cid_ds 作为键存储
      this.real_time_stat_by_reg_date_list.forEach(statItem => {
        // 处理空值情况
        const aid = statItem.aid || '';
        const cid = statItem.cid || '';
        const ds = statItem.reg_ds || '';

        const key = `${aid}_${cid}_${ds}`;
        statMap.set(key, statItem);
      });

      // 创建 projectList 的映射，使用 campaignId 和 cate 作为键
      const projectMap = new Map();
      if (this.projectList && Array.isArray(this.projectList)) {
        this.projectList.forEach(project => {
          // 使用 campaignId 和 cate 作为键进行匹配
          const campaignId = project.campaignId || '';
          const cate = project.cate || '';
          const key = `${campaignId}_${cate}`;

          projectMap.set(key, project);
        });
      }

      // 合并数据
      const mergedData = this.realTimeRoiData.map(roiItem => {
        // 构建匹配键
        const aid = roiItem.aid || '';
        const cid = roiItem.cid || '';
        const ds = roiItem.ds || '';
        const key = `${aid}_${cid}_${ds}`;

        // 查找对应的 stat 数据
        const statItem = statMap.get(key) || {};

        // 构建 projectList 匹配键（使用 roiItem 中的 campaignId 和 cate 字段）
        const campaignId = roiItem.campaignId || roiItem.cid || '';
        const cate = roiItem.ds || '';
        const projectKey = `${campaignId}_${cate}`;
        const projectItem = projectMap.get(projectKey) || {};

        // 合并对象的属性
        return {
          ...roiItem,
          ...statItem,
          // 添加 projectList 中的特定字段
          projectType: projectItem.projectType,
          validClickCount: projectItem.validClickCount,

          advertiserId: projectItem.advertiserId,
        };
      });

      console.log("匹配:",mergedData)
      return mergedData;
    }
    ,upadateToken(){

      this.$confirm('确定要刷新接口调用凭证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      this.$axios
          .post('https://chengmei.games:4443/api/wx/updateAccessToken', {"appid":this.appid})
          .then(successResponse => {
            if (successResponse.data.code === 200) {

              this.$message({
                message: '刷新调用凭证成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });
            }
          })
      }).catch(() => {
        // 用户点击取消后的操作（可选）
        this.$message({
          type: 'info',
          message: '已取消刷新'
        });
      });

    },

    // 修改 updateDisplayData 方法，在分组前先合并数据
    updateDisplayData() {
      // 先合并数据
      switch(this.groupType) {
        case 'none':
          // 不分组时也需要合并数据
          this.displayData = this.mergeDataByAidCidDs();
          console.log("=====",this.displayData)
          break;
        case 'date':
          this.displayData = this.groupByDate(this.mergeDataByAidCidDs());
          break;
        case 'aidDate':
          this.displayData = this.groupByAidAndDate(this.mergeDataByAidCidDs());
          break;
        case 'cidDate':
          this.displayData = this.groupByCidAndDate(this.mergeDataByAidCidDs());
          break;
        case 'aid':
          this.displayData = this.groupByAid(this.mergeDataByAidCidDs());
          break;
        default:
          this.displayData = this.mergeDataByAidCidDs();
      }
    }, formatGroupValue(value) {
      // 添加空值检查和默认值处理
      if (value === undefined || value === null || value === '') {
        return '';
      }
      // 检查是否为有效数字
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        return '';
      }
      return parseFloat(numValue.toFixed(2));
    },// 按广告ID分组
    groupByAid(data = this.mergeDataByAidCidDs()) {
      if (!data || data.length === 0) return [];

      // 按广告ID分组并求和
      const grouped = {};
      data.forEach(item => {
        const aid = item.aid || '未知';
        if (!grouped[aid]) {
          grouped[aid] = {
            ds: '-', // 日期字段设为占位符
            aid: aid,
            cid: item.cid || '未知', // 加入计划ID
            advertiserId: item.advertiserId || '未知', // 加入账户ID
            advertise_ad_exp_cnt: 0,
            advertise_ad_clk_cnt: 0,
            advertise_ad_clk_ratio: 0,
            advertise_ad_cost: 0,
            monetize_ad_income: 0,
            ad_roi: 0,
            ad_arpu: 0,
            advertise_reg_uv: 0,
            reg_paid: 0,
            monetize_ad_income_3d: 0,
            monetize_ad_income_7d: 0,
            monetize_exp_cnt_1d: 0,
            monetize_uv_1d: 0,
            count: 0,
            totalCost: 0
          };
        }

        const group = grouped[aid];
        group.advertise_ad_exp_cnt += item.advertise_ad_exp_cnt || 0;
        group.advertise_ad_clk_cnt += item.advertise_ad_clk_cnt || 0;
        group.advertise_ad_cost += item.advertise_ad_cost || 0;
        group.monetize_ad_income += item.monetize_ad_income || 0;
        group.advertise_reg_uv += item.advertise_reg_uv || 0;
        group.reg_paid += item.reg_paid || 0;
        group.monetize_ad_income_3d += item.monetize_ad_income_3d || 0;
        group.monetize_ad_income_7d += item.monetize_ad_income_7d || 0;
        group.monetize_exp_cnt_1d += item.monetize_exp_cnt_1d || 0;
        group.monetize_uv_1d += item.monetize_uv_1d || 0;
        group.count += 1;
        group.totalCost += item.advertise_ad_cost || 0;

        // 点击率需要重新计算
        if (group.advertise_ad_exp_cnt > 0) {
          group.advertise_ad_clk_ratio = group.advertise_ad_clk_cnt / group.advertise_ad_exp_cnt;
        }
      });

      // 计算加权平均值
      Object.values(grouped).forEach(group => {
        if (group.totalCost > 0) {
          group.ad_roi = group.monetize_ad_income / group.advertise_ad_cost;
          group.ad_arpu = group.monetize_ad_income / group.advertise_reg_uv;
        }

        // 应用格式化函数到数值字段
        group.advertise_ad_cost = this.formatGroupValue(group.advertise_ad_cost);
        group.monetize_ad_income = this.formatGroupValue(group.monetize_ad_income);
        group.monetize_ad_income_3d = this.formatGroupValue(group.monetize_ad_income_3d);
        group.monetize_ad_income_7d = this.formatGroupValue(group.monetize_ad_income_7d);
        group.reg_paid = this.formatGroupValue(group.reg_paid);
        group.ad_arpu = this.formatGroupValue(group.ad_arpu);

        delete group.totalCost;
        delete group.count;
      });

      return Object.values(grouped);
    },

    // 更新各个分组方法，接收处理后的数据作为参数
    groupByDate(data = this.mergeDataByAidCidDs()) {
      if (!data || data.length === 0) return [];

      // 按日期分组并求和
      const grouped = {};
      data.forEach(item => {
        const date = item.ds;
        if (!grouped[date]) {
          grouped[date] = {
            ds: date,
            aid: '日期汇总',
            cid: '-',
            advertise_ad_exp_cnt: 0,
            advertise_ad_clk_cnt: 0,
            advertise_ad_clk_ratio: 0,
            advertise_ad_cost: 0,
            monetize_ad_income: 0,
            ad_roi: 0,
            ad_arpu: 0,
            advertise_reg_uv: 0,
            reg_paid: 0,
            monetize_ad_income_3d: 0,
            monetize_ad_income_7d: 0,
            monetize_exp_cnt_1d: 0,
            monetize_uv_1d: 0,
            count: 0,
            totalCost: 0
          }
        }

        const group = grouped[date];
        group.advertise_ad_exp_cnt += item.advertise_ad_exp_cnt || 0;
        group.advertise_ad_clk_cnt += item.advertise_ad_clk_cnt || 0;
        group.advertise_ad_cost += item.advertise_ad_cost || 0;
        group.monetize_ad_income += item.monetize_ad_income || 0;
        group.advertise_reg_uv += item.advertise_reg_uv || 0;
        group.reg_paid += item.reg_paid || 0;
        group.monetize_ad_income_3d += item.monetize_ad_income_3d || 0;
        group.monetize_ad_income_7d += item.monetize_ad_income_7d || 0;
        group.monetize_exp_cnt_1d += item.monetize_exp_cnt_1d || 0;
        group.monetize_uv_1d += item.monetize_uv_1d || 0;
        group.count += 1;
        group.totalCost += (item.advertise_ad_cost || 0);

        // 点击率需要重新计算
        if (group.advertise_ad_exp_cnt > 0) {
          group.advertise_ad_clk_ratio = group.advertise_ad_clk_cnt / group.advertise_ad_exp_cnt;
        }
      });

      // 计算加权平均值
      Object.values(grouped).forEach(group => {
        if (group.totalCost > 0) {
          group.ad_roi = group.monetize_ad_income / group.advertise_ad_cost;
          group.ad_arpu = group.monetize_ad_income / group.advertise_reg_uv;
        }
        group.advertise_ad_cost = this.formatGroupValue(group.advertise_ad_cost);
        group.monetize_ad_income = this.formatGroupValue(group.monetize_ad_income);
        group.monetize_ad_income_3d = this.formatGroupValue(group.monetize_ad_income_3d);
        group.monetize_ad_income_7d = this.formatGroupValue(group.monetize_ad_income_7d);
        group.reg_paid = this.formatGroupValue(group.reg_paid);
        group.ad_arpu = this.formatGroupValue(group.ad_arpu);
        delete group.totalCost;
        delete group.count;
      });

      return Object.values(grouped);
    },

    groupByAidAndDate(data = this.mergeDataByAidCidDs()) {
      if (!data || data.length === 0) return [];

      // 按广告ID和日期分组并求和
      const grouped = {};
      data.forEach(item => {
        const key = `${item.aid || ''}_${item.ds}`;
        if (!grouped[key]) {
          grouped[key] = {
            ds: item.ds,
            aid: item.aid || '未知',
            cid: '广告汇总',
            advertise_ad_exp_cnt: 0,
            advertise_ad_clk_cnt: 0,
            advertise_ad_clk_ratio: 0,
            advertise_ad_cost: 0,
            monetize_ad_income: 0,
            ad_roi: 0,
            ad_arpu: 0,
            advertise_reg_uv: 0,
            reg_paid: 0,
            monetize_ad_income_3d: 0,
            monetize_ad_income_7d: 0,
            monetize_exp_cnt_1d: 0,
            monetize_uv_1d: 0,
            count: 0,
            totalCost: 0
          }
        }

        const group = grouped[key];
        group.advertise_ad_exp_cnt += item.advertise_ad_exp_cnt || 0;
        group.advertise_ad_clk_cnt += item.advertise_ad_clk_cnt || 0;
        group.advertise_ad_cost += item.advertise_ad_cost || 0;
        group.monetize_ad_income += item.monetize_ad_income || 0;
        group.advertise_reg_uv += item.advertise_reg_uv || 0;
        group.reg_paid += item.reg_paid || 0;
        group.monetize_ad_income_3d += item.monetize_ad_income_3d || 0;
        group.monetize_ad_income_7d += item.monetize_ad_income_7d || 0;
        group.monetize_exp_cnt_1d += item.monetize_exp_cnt_1d || 0;
        group.monetize_uv_1d += item.monetize_uv_1d || 0;
        group.count += 1;
        group.totalCost += (item.advertise_ad_cost || 0);

        // 点击率需要重新计算
        if (group.advertise_ad_exp_cnt > 0) {
          group.advertise_ad_clk_ratio = group.advertise_ad_clk_cnt / group.advertise_ad_exp_cnt;
        }
      });

      // 计算加权平均值
      Object.values(grouped).forEach(group => {
        if (group.totalCost > 0) {
          group.ad_roi = group.monetize_ad_income / group.advertise_ad_cost;
          group.ad_arpu = group.monetize_ad_income / group.advertise_reg_uv;
        }
        group.advertise_ad_cost = this.formatGroupValue(group.advertise_ad_cost);
        group.monetize_ad_income = this.formatGroupValue(group.monetize_ad_income);
        group.monetize_ad_income_3d = this.formatGroupValue(group.monetize_ad_income_3d);
        group.monetize_ad_income_7d = this.formatGroupValue(group.monetize_ad_income_7d);
        group.reg_paid = this.formatGroupValue(group.reg_paid);
        group.ad_arpu = this.formatGroupValue(group.ad_arpu);
        delete group.totalCost;
        delete group.count;
      });

      return Object.values(grouped);
    },

    // 修改 groupByCidAndDate 方法，添加 projectList 匹配逻辑
    groupByCidAndDate(data = this.mergeDataByAidCidDs()) {
      if (!data || data.length === 0) return [];

      // 创建 projectList 的映射，使用 campaignId 和 cate 作为键
      const projectMap = new Map();
      if (this.projectList && Array.isArray(this.projectList)) {
        this.projectList.forEach(project => {
          // 使用 campaignId 和 cate 作为键进行匹配
          const campaignId = project.campaignId || '';
          const cate = project.cate || '';
          const key = `${campaignId}_${cate}`;

          projectMap.set(key, project);
        });
      }

      // 按创意ID和日期分组并求和
      const grouped = {};
      data.forEach(item => {
        const key = `${item.cid || ''}_${item.ds}`;
        if (!grouped[key]) {
          // 构建 projectList 匹配键
          const campaignId = item.cid || '';
          const cate = item.ds || '';
          const projectKey = `${campaignId}_${cate}`;
          const projectItem = projectMap.get(projectKey) || {};

          grouped[key] = {
            ds: item.ds,
            aid: '创意汇总',
            cid: item.cid || '未知',
            advertise_ad_exp_cnt: 0,
            advertise_ad_clk_cnt: 0,
            advertise_ad_clk_ratio: 0,
            advertise_ad_cost: 0,
            monetize_ad_income: 0,
            ad_roi: 0,
            ad_arpu: 0,
            advertise_reg_uv: 0,
            reg_paid: 0,
            monetize_ad_income_3d: 0,
            monetize_ad_income_7d: 0,
            monetize_exp_cnt_1d: 0,
            monetize_uv_1d: 0,
            count: 0,
            totalCost: 0,
            // 添加 projectList 中的特定字段
            projectType: projectItem.projectType,
            validClickCount: projectItem.validClickCount,
            advertiserId: projectItem.advertiserId,
          }
        }

        const group = grouped[key];
        group.advertise_ad_exp_cnt += item.advertise_ad_exp_cnt || 0;
        group.advertise_ad_clk_cnt += item.advertise_ad_clk_cnt || 0;
        group.advertise_ad_cost += item.advertise_ad_cost || 0;
        group.monetize_ad_income += item.monetize_ad_income || 0;
        group.advertise_reg_uv += item.advertise_reg_uv || 0;
        group.reg_paid += item.reg_paid || 0;
        group.monetize_ad_income_3d += item.monetize_ad_income_3d || 0;
        group.monetize_ad_income_7d += item.monetize_ad_income_7d || 0;
        group.monetize_exp_cnt_1d += item.monetize_exp_cnt_1d || 0;
        group.monetize_uv_1d += item.monetize_uv_1d || 0;
        group.count += 1;
        group.totalCost += (item.advertise_ad_cost || 0);

        // 点击率需要重新计算
        if (group.advertise_ad_exp_cnt > 0) {
          group.advertise_ad_clk_ratio = group.advertise_ad_clk_cnt / group.advertise_ad_exp_cnt;
        }
      });

      // 计算加权平均值
      Object.values(grouped).forEach(group => {
        if (group.totalCost > 0) {
          group.ad_roi = group.monetize_ad_income / group.advertise_ad_cost;
          group.ad_arpu = group.monetize_ad_income / group.advertise_reg_uv;
        }
        group.advertise_ad_cost_sort = group.advertise_ad_cost;
        group.monetize_ad_income_sort = group.monetize_ad_income;
        group.monetize_ad_income_3d_sort = group.monetize_ad_income_3d;
        group.monetize_ad_income_7d_sort = group.monetize_ad_income_7d;
        group.reg_paid_sort = group.reg_paid;
        group.ad_arpu_sort = group.ad_arpu;
        // 应用格式化函数到数值字段
        group.advertise_ad_cost = this.formatGroupValue(group.advertise_ad_cost);
        group.monetize_ad_income = this.formatGroupValue(group.monetize_ad_income);
        group.monetize_ad_income_3d = this.formatGroupValue(group.monetize_ad_income_3d);
        group.monetize_ad_income_7d = this.formatGroupValue(group.monetize_ad_income_7d);
        group.reg_paid = this.formatGroupValue(group.reg_paid);
        group.ad_arpu = this.formatGroupValue(group.ad_arpu);

        delete group.totalCost;
        delete group.count;
      });

      return Object.values(grouped);
    }
    ,

    // 添加表格行样式类名方法
    tableRowClassName({row, rowIndex}) {
      // 为汇总行添加特殊样式
      if (row.aid === '日期汇总' || row.aid === '未知' || row.cid === '广告汇总' || row.aid === '创意汇总') {
        return 'summary-row';
      }
      return '';
    },

    // 添加点击率样式类
    getRatioClass(ratio) {
      const value = ratio * 100;
      if (value >= 5) return 'high-ratio';
      if (value >= 2) return 'medium-ratio';
      return 'low-ratio';
    },

    // 添加ROI样式类
    getRoiClass(roi) {
      const value = parseFloat(roi);
      if (value >= 1) return 'high-roi';
      if (value >= 0.5) return 'medium-roi';
      if (value < 0) return 'negative-roi';
      return 'low-roi';
    },

    // 初始化列设置
    initColumnSettings() {
      const savedSettings = localStorage.getItem('pluginRedirectColumnSettings');
      if (savedSettings) {
        try {
          this.columnSettings = JSON.parse(savedSettings);
          // 确保所有默认列都在设置中
          this.defaultColumnSettings.forEach(defaultCol => {
            const exists = this.columnSettings.some(col => col.prop === defaultCol.prop);
            if (!exists) {
              this.columnSettings.push({...defaultCol});
            }
          });
        } catch (e) {
          this.columnSettings = [...this.defaultColumnSettings];
        }
      } else {
        this.columnSettings = [...this.defaultColumnSettings];
      }
    },

    // 保存列设置
    saveColumnSettings() {
      localStorage.setItem('pluginRedirectColumnSettings', JSON.stringify(this.columnSettings));
      console.log('保存列设置：', this.columnSettings)
      this.showColumnSettings = false;
      //更新表格
      this.$nextTick(() => {
        // 强制更新表格布局
        this.$forceUpdate();
        // 如果有表格引用，也可以调用 doLayout 方法
        if (this.$refs.t && this.$refs.t.doLayout) {
          this.$refs.t.doLayout();
        }
      });
    },

    // 重置列设置
    resetColumnSettings() {
      this.columnSettings = [...this.defaultColumnSettings];
    },

    setSort() {
      const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '');
        },
        onEnd: evt => {
          const newList = [...this.columnSettings];
          const movedItem = newList.splice(evt.oldIndex, 1)[0];
          newList.splice(evt.newIndex, 0, movedItem);

          // 直接替换整个数组
          this.columnSettings = newList;
        }
      });
    },
  },
  mounted: function () {
    this.findGame()
    // 设置默认日期范围
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.date = [this.formatDate(start), this.formatDate(end)]



    // 初始化缓存的游戏和日期
    this.initCache()
    // 如果已有缓存条件，则自动查询
    if (this.appid && this.date.length === 2) {
      this.get()
    }
  },
  watch: {
    showColumnSettings(val) {
      if (val) {
        this.$nextTick(() => {
          this.setSort();
        });
      } else {
        this.sortable && this.sortable.destroy();
      }
    }
  }
}
</script>

<style scoped>
.plugin-redirect-container {
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
  box-sizing: border-box;
}

/* 查询区域优化 */
.el-row {
  margin-bottom: 12px;
}

/* 按钮和选择器间距优化 */
.el-button--mini {
  margin-left: 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.el-button--mini:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 表格容器优化 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  background: #ffffff;
}

/* 表头样式 - 清新简约 */
.el-table ::v-deep .el-table__header th {
  background-color: #f8fafc !important;
  color: #475569;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 0;
}

/* 表格行样式 */
.el-table ::v-deep .el-table__row {
  transition: background-color 0.2s ease;
}

.el-table ::v-deep .el-table__row:hover {
  background-color: #f8fafc !important;
}

.el-table ::v-deep .el-table__cell {
  padding: 8px 0;
  font-size: 13px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

/* 汇总行样式 - 浅色背景 */
.summary-row {
  background-color: #f0fdf4 !important;
  font-weight: 600;
}

.summary-row:hover {
  background-color: #dcfce7 !important;
}

/* ROI颜色样式 - 柔和色系 */
.high-roi {
  color: #10b981;
  font-weight: 600;
}

.medium-roi {
  color: #f59e0b;
}

.low-roi {
  color: #94a3b8;
}

.negative-roi {
  color: #ef4444;
  font-weight: 600;
}

/* 点击率颜色样式 */
.high-ratio {
  color: #10b981;
  font-weight: 600;
}

.medium-ratio {
  color: #f59e0b;
}

.low-ratio {
  color: #94a3b8;
}

/* 链接样式 */
.el-table a,
.el-table span[style*="cursor: pointer"] {
  color: #3b82f6;
  transition: color 0.2s ease;
}

.el-table a:hover,
.el-table span[style*="cursor: pointer"]:hover {
  color: #2563eb;
  text-decoration: underline;
}

/* 弹窗样式优化 */
.el-dialog {
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.el-dialog__header {
  border-bottom: 1px solid #f1f5f9;
  padding: 16px 20px;
}

.el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.el-dialog__body {
  padding: 20px;
}

/* 拖拽排序样式 */
.sortable-ghost {
  opacity: 0.6;
  background: #e0f2fe !important;
  color: #0369a1 !important;
}

/* 列设置表格优化 */
.el-alert {
  border-radius: 6px;
  margin-bottom: 16px;
}

/* 响应式优化 */
@media (max-width: 1200px) {
  .plugin-redirect-container {
    padding: 12px;
  }
  
  .el-table {
    width: 100% !important;
  }
}

/* 滚动条美化 */
.el-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.el-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.el-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.el-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f8fafc;
}
</style>
